var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDecode = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M11.374 13.17a.9.9 0 0 0-.585.002l.034-.041q.018-.023.037-.043l.81-.968h-.518a.4.4 0 0 0-.187.04.3.3 0 0 0-.124.093l-.615.83a1.8 1.8 0 0 0-.232.413 1.15 1.15 0 0 0-.013.803q.067.18.193.31a.9.9 0 0 0 .31.202q.18.07.41.071.223 0 .407-.075a.91.91 0 0 0 .587-.866.9.9 0 0 0-.072-.364.74.74 0 0 0-.442-.407m-.876.994a.63.63 0 0 1 .006-.364.36.36 0 0 1 .21-.227.5.5 0 0 1 .338-.002.37.37 0 0 1 .223.225.52.52 0 0 1-.002.362.41.41 0 0 1-.39.264.5.5 0 0 1-.182-.03.34.34 0 0 1-.128-.09.4.4 0 0 1-.075-.138m3.58-.374h-.281v-1.67h-.556l-1.263 1.699.06.287a.14.14 0 0 0 .054.084.16.16 0 0 0 .1.034h1.098v.628h.507v-.628h.168q.055 0 .083-.032a.1.1 0 0 0 .03-.075v-.326Zm-.784-.852a2 2 0 0 0-.004.14v.713h-.703l.722-1.011z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M10.313 9.75V8.679q0-.67.492-1.139A1.67 1.67 0 0 1 12 7.071q.59 0 1.034.342.443.342.597.85a.54.54 0 0 0 .232.302.7.7 0 0 0 .387.114.57.57 0 0 0 .4-.148.35.35 0 0 0 .12-.348q-.155-.91-.935-1.547T12 6q-1.167 0-1.99.783-.822.784-.822 1.896V9.75H8.25a1.5 1.5 0 0 0-1.5 1.5v4.5a1.5 1.5 0 0 0 1.5 1.5h7.5a1.5 1.5 0 0 0 1.5-1.5v-4.5a1.5 1.5 0 0 0-1.5-1.5zm-2.063.9a.6.6 0 0 0-.6.6v4.5a.6.6 0 0 0 .6.6h7.5a.6.6 0 0 0 .6-.6v-4.5a.6.6 0 0 0-.6-.6z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDecode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/decode.ef3758d1.svg";